import type { InlineInputProps } from '@ztechapps/webui.input'
import { ProductStatusSelectInlineInput } from '../ProductStatus/ProductStatusSelectInlineInput'
import React from 'react'
import isEmpty from 'lodash/isEmpty'

export const ProductStatusInlineInput = (props: InlineInputProps) => {
  return (
    <ProductStatusSelectInlineInput
      label="Status"
      help="Status affects the visibility of product on store"
      name="status"
      validate={(e) => {
        if (isEmpty(e)) throw new Error('Required to have a value.')
      }}
      {...props}
    />
  )
}
